import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GlossaryDialogComponent } from '../../../../shared/components/glossary-dialog/glossary-dialog.component';
import { YTBesprechung, YTBesprechungChannels } from '../../../../generated-api';
import { MediaDialogComponent, MediaDialogMode } from '../../../../shared/components/media-dialog/media-dialog.component';
import { NoteDialogComponent } from '../../../../shared/components/note-dialog/note-dialog.component';

@Component({
    selector: 'app-ytb-detail-icon-list',
    templateUrl: './ytb-detail-icon-list.component.html',
    styleUrls: ['./ytb-detail-icon-list.component.scss'],
    standalone: false
})
export class YtbDetailIconListComponent implements OnInit {
  @Input() ytbesprechung: YTBesprechung;
  sortedChannels = [];

  constructor(private dialog: MatDialog, private translateService: TranslateService) {

  }



  ngOnInit(): void {
    const yt = this.ytbesprechung.channels.find(e => e.channelname === 'youtube');
    const tt = this.ytbesprechung.channels.find(e => e.channelname === 'tiktok');
    const ig = this.ytbesprechung.channels.find(e => e.channelname === 'instagram');
    if (yt != null) this.sortedChannels.push(yt);
    if (tt != null) this.sortedChannels.push(tt);
    if (ig != null) this.sortedChannels.push(ig);
  }

  handleChipClick(c: string): void {
    this.dialog.open(GlossaryDialogComponent, {
      width: '300px',
      data: {
        name: c
      }
    });
  }

  handleSocialMediaClick(channel: YTBesprechungChannels, channelUri: string): void {
    this.dialog.open(MediaDialogComponent, {
      width: '400px',
      data: {
        src: channel.channelname,
        besprechungId: null,
        ytKids: channel.channelname === 'youtubekids',
        sourceType: 'streaming',
        mode: MediaDialogMode.youtube,
        url: channelUri,
        rating: this.ytbesprechung.rating.id
      }
    });
  }

  // handleYoutubeClick(): void {
  //   this.dialog.open(MediaDialogComponent, {
  //     width: '400px',
  //     data: {
  //       src: 'youtube',
  //       besprechungId: null,
  //       sourceType: 'streaming',
  //       mode: MediaDialogMode.youtube,
  //       url: this.ytbesprechung.channeluri,
  //       rating: this.ytbesprechung.rating.id
  //     }
  //   });
  // }

  // handleYoutubeKidsClick(): void {
  //   this.dialog.open(MediaDialogComponent, {
  //     width: '400px',
  //     data: {
  //       src: 'youtubekids',
  //       besprechungId: null,
  //       ytKids: true,
  //       sourceType: 'streaming',
  //       mode: MediaDialogMode.youtube,
  //       url: this.ytbesprechung.kidchannelsuri,
  //       rating: this.ytbesprechung.rating.id
  //     }
  //   });
  // }

  openNoteModal(): void {
    this.dialog.open(NoteDialogComponent, {
      width: '300px',
      data: {
        title: this.translateService.instant('ytb.noteDialog.title'),
        text: this.translateService.instant('ytb.noteDialog.text')
      }
    });
  }
}
